import styled from 'styled-components';
import WithDirection from '@iso/lib/helpers/rtl';

const ManageUserProductPage = styled.div`
  width: 100%;
  height: 100%;
  
  span.anticon.anticon-ellipsis {
    rotate: 90deg;
}
.manage-property-header {
  padding: 20px 15px;
  display: flex;
  align-items: center;
  margin: auto;
}
.manage-property-title {
  color: #101828;
  font-weight: 600;
  font-size: 18px;
  line-height: 28px;
}
 .manage-property-header > .mp-title {
   width: 100%;
}
.table_visiter .react-collapsible tbody .title {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #101828;
}
  .btn-success{
    border-color: #0B2A1B;
    margin-right: 10px;
    background-color: #f80e46;
    padding: 8px;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: normal;
    padding-left:15px;
    padding-right:15px;
    :hover{
      opacity:1;
    }
    span{
      margin-right:8px;
    }
  }
  .button-group {
    width: 100%;
  
    margin-bottom: 10px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
  }
  .fAgWDa .ant-table-content{
    overflow-x: unset;
  }
  .fAgWDa{
    overflow-x: unset;
  }
  .dtr-data{
    white-space: break-spaces;
  }
  iframe {
    height: 500px;
    width: 100%;
  }
  .signature-area {
    margin-bottom: 20px;
    canvas{
      border: solid 1px black;
      max-width: 100%;
      width: 100%;
      height: 300px;
      max-height: 250px;
    }
  }

  .signature-clear-button {
    display: block;
  }
  .action-button{
    margin-right: 10px;
  }
  .signature-image{
    max-width: 200px
  }
  td.signature{
    text-align: center
  }
  .visiter_table_main{
    background: rgb(255, 255, 255);
    border: 1px solid rgb(229, 229, 229);
    box-sizing: border-box;
    box-shadow: rgba(229, 229, 229, 0.6) 1px 1px 10px;
    border-radius: 10px;
    .top_title_visiter{
     padding:20px 24px;
      display: flex;
      -webkit-box-align: center;
      align-items: center;
      margin: auto;
      h1{
        margin-right : 0px !important;
        
          // color: rgb(120, 129, 149);
          color: rgb(16, 24, 40);
          font-weight: 600;
          font-size: 18px;
          line-height: 28px;
        :after{
          display:none
        }
        :before{
          display:none
        }
      }
      .button-group{
        button{
          border-radius:8px !important;
         
        }
        .ant-select{
          border-radius:8px !important;
          .ant-select-selector{
            border-radius:8px !important;
            border: 1px solid #d0d5dd !important;

          }
        }
      }
      .VerticalDivider{
        border-left:4px solid rgba(0, 0, 0, 0.08);
        height:35px;
      }
      .HorizontalDeivider{
        // margin-left : 20px;
        min-width : 93.5% !important;
      }
    }
    .table_visiter .react-collapsible tbody .name {
      font-family: "Inter";
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: #101828;
    }
    // .react-collapsible-theme .brand-primary-light {
    //   color: rgb(248, 14, 70) !important;
    // }
    .table_visiter{
      box-shadow: none !important;
      border-radius: 0 !important;
      .react-collapsible-theme{
        .react-collapsible{
          box-shadow: none !important;
          border-radius: 0 !important;
          border-top: 1px solid rgb(229, 229, 229)!important;
          tbody{
            .actions{
              text-align:right;
              .ant-btn{
                border-radius:8px !important;
              }
            }
          }
        }
      }

    }
  }
  @media only screen and (max-width : 454px){
   .manage-property-header{
    gap: 1rem;
    flex-wrap: wrap !important; 
    .button-group {
      justify-content : flex-start !important;
     .btn-success{
      width: 100%;
     }
    }
   }
  }
`;

export default WithDirection(ManageUserProductPage);